<template>
  <v-container fluid>
    <v-toolbar flat color="#FAFAFA" >
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')"></v-toolbar-side-icon-->
      <v-toolbar-title >Distribuir Produtos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" light flat to="/distribuir/pacote">
       <v-icon left>add</v-icon>
      Criar Pacote</v-btn>
    </v-toolbar>

    <v-card flat>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Busca" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="packages" 
        :search="search"
        :pagination.sync="pagination_default"
        no-data-text="Nenhum pacote encontrado."
        no-results-tex="Nenhum resultado encontrado."
      >
        <template slot="items" slot-scope="props" >
          <td>{{props.item.package_name}}</td>
          <td>{{props.item.created_at}}</td>
          <td>{{props.item.action}}</td>          
          <td  class="text-xs-center">{{props.item.total_products}}</td>
          
          <td class="text-xs-center">processando</td>
          <td class="text-xs-right">
            <v-menu offset-x left bottom>
              <v-btn icon slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <!--v-list>
                <v-list-tile>
                  <v-list-tile-title>Editar</v-list-tile-title>
                </v-list-tile>                
              </v-list-->
            </v-menu>
          </td>
        </template>

        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >A sua busca por "{{ search }}" não teve resultados.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import PackageService from "../app/Rest/package";

var packageService =null;

export default {
  data() {
    return {
      search: "",
      pagination_default:{'sortBy': 'created_at', 'descending': true, 'rowsPerPage': 40},
      headers: [
        {
          text: "Pacote",
          align: "left",
          sortable: false,
          value: "package_name"
        },
        {
          text: "Criado",
          align: "left",
          sortable: true,
          value: "created_at"
        },
        {
          text: "Ação",
          align: "left",
          sortable: false,
          value: "action"
        },         
         {
          text: "Quantidade de produtos",
          align: "center",
          sortable: true,
          value: "total_products"
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status"
        },
        {
          text: "Ações",
          align: "right",
          sortable: false,
          value: "acoes"
        }
      ],
      packages: []
    };
  },
  methods: {
    fetchRecords() {      
      packageService =  PackageService.build();
      packageService.search({}).then(this.fetchRecodsSuccess);
    },
    fetchRecodsSuccess(response) {
      if (Array.isArray(response.items.packages)) {
        this.packages = response.items.packages;
        return;
      }
      this.rows = [];
    }
  },
  mounted() {
    
    this.fetchRecords();
  }
};
</script>